import { lazy } from 'react';

const Historia = lazy(() => import('../../historia/Historia.jsx'));

const historiaRoutes = [
      {
            path: 'historia',
            element: <Historia />,
      },
];

export default historiaRoutes;
